import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const RadioButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  > div:first-of-type {
    margin-right: 30px;
  }

  @media (max-width: 520px) {
    align-self: flex-end;
    margin-top: 20px;
  }
`